var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-hbl" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: { no: "1", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyCargoDescriptionAndMarks"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyCargoDescriptionAndMarks"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { command: _vm.$t("SeaExport.CopyMbl") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.CopyMbl")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "2",
                          disabled: _vm.btnPrintDisabled,
                          type: "primary"
                        },
                        on: { click: _vm.originalPrint }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.releaseType === 1
                              ? _vm.$t("SeaExport.PrintTheOriginalBl")
                              : _vm.$t("SeaExport.TelexRelease")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.readonly && _vm.form.state == 2,
                            expression: "readonly && form.state==2 "
                          }
                        ],
                        attrs: {
                          no: "3",
                          type: "primary",
                          disabled: !_vm.readonly && _vm.unlockDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.onSubmitStateEvent()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "4",
                          disabled: _vm.readonly || !_vm.form.uuid,
                          type: "primary"
                        },
                        on: { click: _vm.showAddressFormatDialog }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.AntiTerroristFormattedAddress")
                          )
                        )
                      ]
                    ),
                    _vm.viewSource === "SiBooking"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_insurance_toInsure"],
                                expression: "['button_insurance_toInsure']"
                              }
                            ],
                            attrs: {
                              no: "5",
                              disabled: _vm.isEdit,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.toInsure()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          no: "6",
                          value: _vm.form.state === 2,
                          disabled: true
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Message.Locked")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "7", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.BlBeReleasedElsewhereOrNot"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "8", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.manifestEDI,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "manifestEDI", $$v)
                          },
                          expression: "form.manifestEDI"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ManifestEdi")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "9", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam1", $$v)
                          },
                          expression: "form.printParam1"
                        }
                      },
                      [_vm._v("Part of")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "10", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam2", $$v)
                          },
                          expression: "form.printParam2"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ClauseOfNoWoodPackingMaterial")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "11", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.chkConsolidationClosed,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chkConsolidationClosed", $$v)
                          },
                          expression: "form.chkConsolidationClosed"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AFRTheLastBill")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "12", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam6,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam6", $$v)
                          },
                          expression: "form.printParam6"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PrintBargeVesselAndVoyage"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: {
                          no: "13",
                          value: _vm.form.customerSelfRelease === 1,
                          disabled: _vm.readonly
                        },
                        on: {
                          input: function(val) {
                            _vm.pm.isCustomerSelfRelease(val)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerSelfRelease")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: {
                          no: "14",
                          value: _vm.form.customerSelfRelease === 2,
                          disabled: _vm.readonly
                        },
                        on: {
                          input: function(val) {
                            _vm.pm.isCompanySelfRelease(val)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CompanySelfRelease")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "down-first section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "label-width": _vm.isZh ? "70px" : "75px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                          )
                        )
                      ]),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))
                              ]),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "shipper" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { flex: "1" },
                                attrs: { disabled: _vm.readonly, no: "15" },
                                model: {
                                  value: _vm.form.shipperCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperCode", $$v)
                                  },
                                  expression: "form.shipperCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "16",
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "method-params": {
                                    partnerManagementMode:
                                      _vm.partnerManagementMode,
                                    branchId:
                                      _vm.$store.getters.currentOfficeId,
                                    shipper: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.shipperId || "",
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.senderAndReceiverChange("shipper", p, 7)
                                  }
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clearSenderAndReceiver(
                                        "shipper",
                                        7
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "shipperLine" + count,
                            class:
                              "auto-width " +
                              _vm.getSenderAndReceiverColor(
                                "shipperLine",
                                count
                              )
                          },
                          [
                            _c("cargo-input", {
                              ref: "shipperLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "shipperLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "shipperLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "shipper",
                                    7,
                                    false,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["shipperLine" + count],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine" + count, $$v)
                                },
                                expression: "form['shipperLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))
                              ]),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "consignee" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { flex: "1" },
                                attrs: { disabled: _vm.readonly, no: "17" },
                                model: {
                                  value: _vm.form.consigneeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeCode", $$v)
                                  },
                                  expression: "form.consigneeCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { width: "157px", flex: "1" },
                                attrs: {
                                  no: "18",
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "method-params": {
                                    partnerManagementMode:
                                      _vm.partnerManagementMode,
                                    branchId:
                                      _vm.$store.getters.currentOfficeId,
                                    consignee: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.consigneeId || "",
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.senderAndReceiverChange(
                                      "consignee",
                                      p,
                                      7
                                    )
                                  }
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    no: "19",
                                    disabled: _vm.readonly,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clearSenderAndReceiver(
                                        "consignee",
                                        7
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "consigneeLine" + count,
                            class:
                              "auto-width " +
                              _vm.getSenderAndReceiverColor(
                                "consigneeLine",
                                count
                              )
                          },
                          [
                            _c("cargo-input", {
                              ref: "consigneeLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "consigneeLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "consignee",
                                    7,
                                    false,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["consigneeLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "consigneeLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['consigneeLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))
                              ]),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "notify" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { flex: "1", width: "120px" },
                                attrs: { disabled: _vm.readonly, no: "20" },
                                model: {
                                  value: _vm.form.notifyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyCode", $$v)
                                  },
                                  expression: "form.notifyCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticStyle: { flex: "1", width: "120px" },
                                attrs: {
                                  no: "21",
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "method-params": {
                                    partnerManagementMode:
                                      _vm.partnerManagementMode,
                                    branchId:
                                      _vm.$store.getters.currentOfficeId,
                                    notify: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.notifyId || "",
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.senderAndReceiverChange("notify", p, 7)
                                  }
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    no: "22",
                                    disabled: _vm.readonly,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clearSenderAndReceiver(
                                        "notify",
                                        7
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    no: "23",
                                    disabled: _vm.readonly,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onCopy_consignee()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CopyTheConsignee"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "notifyLine" + count,
                            class:
                              "auto-width " +
                              _vm.getSenderAndReceiverColor("notifyLine", count)
                          },
                          [
                            _c("cargo-input", {
                              ref: "notifyLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "notifyLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "notify",
                                    7,
                                    false,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["notifyLine" + count],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine" + count, $$v)
                                },
                                expression: "form['notifyLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "#404144!important" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AgentInfo")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "min-width": "50px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "24",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(4)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c(
                              "el-dropdown",
                              {
                                class: _vm.readonly ? "not-click" : "",
                                attrs: {
                                  no: "25",
                                  disabled: _vm.readonly,
                                  "split-button": "",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.commandHandle(_vm.command3)
                                  },
                                  command: function(p) {
                                    this$1.command3 = p
                                    _vm.commandHandle(_vm.command3)
                                  }
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.command3) + " "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.CopyMblConsignee"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.CopyMblConsignee")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.CopyNominatedAgentInfo"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CopyNominatedAgentInfo"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "agentPartyLine" + count,
                            class:
                              "auto-width " +
                              _vm.getSenderAndReceiverColor(
                                "agentPartyLine",
                                count
                              )
                          },
                          [
                            _c("cargo-input", {
                              ref: "agentPartyLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "agentPartyLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "agentPartyLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "agentPartyLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "agentParty",
                                    7,
                                    false,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["agentPartyLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "agentPartyLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['agentPartyLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("span", { staticStyle: { color: "#404144" } }, [
                          _vm._v("ALSO NOTIFY")
                        ])
                      ]),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "26",
                              disabled: !_vm.isEdit,
                              "text-chars": _vm.maxChars,
                              "warning-count": _vm.warningCount,
                              "use-read-only": true
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  "ALSO NOTIFY",
                                  _vm.form.alsoNotify,
                                  function(val) {
                                    _vm.form.alsoNotify = _vm.notUppercaseShipperConsigneNotify
                                      ? val.toUpperCase()
                                      : val
                                  },
                                  false,
                                  null,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form.alsoNotify,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "alsoNotify", $$v)
                              },
                              expression: "form.alsoNotify"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "down-two section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": _vm.isZh ? "125px" : "160px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.NumberOfPackagesOnBl")
                          }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "27",
                              precision: 0,
                              min: 0,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.quantity_Change()
                              }
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.packing,
                          attrs: { label: _vm.$t("SeaExport.Package") }
                        },
                        [
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "28",
                              "default-value": _vm.form.packing,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.packing_Change(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insideQuantity,
                          attrs: { label: _vm.$t("SeaExport.Pieces2") }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "29",
                              precision: 0,
                              min: 0,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.insideQuantity_Change($event)
                              }
                            },
                            model: {
                              value: _vm.form.insideQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "insideQuantity", $$v)
                              },
                              expression: "form.insideQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insidePacking,
                          attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                        },
                        [
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "30",
                              "default-value": _vm.form.insidePacking,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function(p) {
                                _vm.form.insidePacking = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: "custom " + _vm.variableCss.weight,
                          attrs: { label: _vm.$t("SeaExport.GrossWeight") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "31",
                                  disabled:
                                    !_vm.pm.isCanEditQwc ||
                                    _vm.isCrossTenantSEToSI,
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.txtWeightChargeHandler()
                                  }
                                },
                                model: {
                                  value: _vm.form.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "weight", $$v)
                                  },
                                  expression: "form.weight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: "custom " + _vm.variableCss.cubage,
                          attrs: { label: _vm.$t("SeaExport.Cubage") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "32",
                                  disabled:
                                    !_vm.pm.isCanEditQwc ||
                                    _vm.isCrossTenantSEToSI,
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.txtCubageChargeHandler()
                                  }
                                },
                                model: {
                                  value: _vm.form.cubage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cubage", $$v)
                                  },
                                  expression: "form.cubage"
                                }
                              }),
                              _c("span", [_vm._v("CBM")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "33",
                                  precision: 3,
                                  min: 0,
                                  disabled: _vm.isCrossTenantSEToSI
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.txtChargeWeightHandler()
                                  }
                                },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "custom" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: { float: "right" },
                              attrs: { no: "34", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getMBLInfo("EName")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.CopyEnglishDescriptionOfGoodsFromMbl"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class:
                            "label-none custom " +
                            _vm.variableCss.cargoEnglishName,
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EnglishCargoName")
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "35",
                              "show-count": true,
                              disabled: !_vm.isEdit || _vm.isCrossTenantSEToSI,
                              "text-chars": _vm.englishNameMaxChars,
                              "warning-count": _vm.englishNameWarningCount,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.txtCargoEnglishNameChangeHandler()
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("queryJob.englishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.form.cargoEnglishName = val
                                  },
                                  false,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    warningCount: _vm.englishNameWarningCount,
                                    maxChar: _vm.englishNameMaxChars
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "custom" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: {
                                float: "right",
                                "margin-left": "5px"
                              },
                              attrs: { no: "36", type: "primary" },
                              on: {
                                change: function($event) {
                                  return _vm.pm.txtMarkChangeHandler()
                                },
                                click: function($event) {
                                  return _vm.pm.getMBLInfo("mark")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyMarksFromMbl"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: "label-none custom " + _vm.variableCss.mark,
                          attrs: { label: _vm.$t("SeaExport.Marks") }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "37",
                              "show-count": true,
                              disabled: !_vm.isEdit || _vm.isCrossTenantSEToSI,
                              "text-chars": _vm.markMaxChars,
                              "warning-count": _vm.markWarningCount,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.txtMarkChangeHandler($event)
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.form.mark = val
                                  },
                                  false,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    warningCount: _vm.markWarningCount,
                                    maxChar: _vm.markMaxChars
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "label-none custom",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.CapitalizedNumbersOfPackages"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "38", disabled: true },
                            model: {
                              value: _vm.form.quantitySum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantitySum", $$v)
                              },
                              expression: "form.quantitySum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "down-three section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": _vm.isZh ? "100px" : "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "HB/L NO." } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "39",
                              disabled:
                                _vm.hblNoDisabled || _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.hblFunction($event)
                              }
                            },
                            model: {
                              value: _vm.form.hblNbr2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hblNbr2", $$v)
                              },
                              expression: "form.hblNbr2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BillOfLadingNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "40" },
                            model: {
                              value: _vm.form.serialNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "serialNo", $$v)
                              },
                              expression: "form.serialNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.vessel") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "41",
                              disabled:
                                _vm.readonly ||
                                !_vm.pm._lclslaveEnabled ||
                                _vm.isCrossTenantSEToSI,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Vessel,
                              filterable: "",
                              clearable: "",
                              "allow-create": _vm.pm._allowEditingVessel,
                              "default-value": _vm.job.vessel
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.onVesselSelectionChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.voyage") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "voyageFlight",
                              attrs: {
                                no: "42",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.pm._lclslaveEnabled ||
                                  _vm.isCrossTenantSEToSI,
                                filterable: "",
                                clearable: "",
                                "allow-create": _vm.pm.editVoyageMode === 1
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.pm.voyageFocusInHandler()
                                },
                                blur: function($event) {
                                  return _vm.pm.voyageFocusOutHandler()
                                }
                              },
                              model: {
                                value: _vm.job.voyageFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "voyageFlight", $$v)
                                },
                                expression: "job.voyageFlight"
                              }
                            },
                            _vm._l(_vm.pm._voyages, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.voyageNo,
                                  value: item.voyageNo
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("queryJob.dateOfDeparture") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "43",
                              value: _vm.job.etd
                                ? _vm.moment(_vm.job.etd).format("YYYY-MM-DD")
                                : null,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dispatchingPlace,
                          attrs: {
                            label: _vm.$t("SeaExport.DocDispatchingPlace")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "44",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.dispatchingPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dispatchingPlace", $$v)
                              },
                              expression: "form.dispatchingPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.loadingPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfLoadingOnBl")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "45",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.loadingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "loadingPort", $$v)
                              },
                              expression: "form.loadingPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dischargingPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDischargeOnBl")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "46",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.dischargingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dischargingPort", $$v)
                              },
                              expression: "form.dischargingPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.destinationPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "47",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.destinationPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPort", $$v)
                              },
                              expression: "form.destinationPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.MethodOfHblPayment")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "48",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value": _vm.job.paymentTermHBL,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.paymentSelectHblChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfHblPayment2")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "49",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.paymentPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "paymentPlaceBL", $$v)
                              },
                              expression: "form.paymentPlaceBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.TransportationClause")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "50",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.freightTermHBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "freightTermHBL", $$v)
                              },
                              expression: "form.freightTermHBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.blNumber,
                          attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "51",
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            model: {
                              value: _vm.form.blNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "blNumber", $$v)
                              },
                              expression: "form.blNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                        [
                          _c("el-input", {
                            attrs: { no: "52" },
                            model: {
                              value: _vm.form.signPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signPlaceBL", $$v)
                              },
                              expression: "form.signPlaceBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "53",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.signDateBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signDateBL", $$v)
                              },
                              expression: "form.signDateBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.remarks,
                          attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "54",
                              disabled: !_vm.isEdit,
                              "text-chars": 0,
                              "warning-count": -1
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.BlRemarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  },
                                  false,
                                  null,
                                  false,
                                  {
                                    warningCount: -1,
                                    maxChar: 0,
                                    autoUppercase: false,
                                    autoHalfWord: false
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "55",
                              type: "textarea",
                              rows: 5,
                              disabled: _vm.isCrossTenantSEToSI
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.HsCode"),
                                  _vm.job.hsCode,
                                  function(val) {
                                    _vm.job.hsCode = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "hsCode", $$v)
                              },
                              expression: "job.hsCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CheckingQuestions")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "56", type: "textarea", rows: 5 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.CheckingQuestions"),
                                  _vm.form.customerCfmException,
                                  function(val) {
                                    _vm.form.customerCfmException = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerCfmException,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerCfmException", $$v)
                              },
                              expression: "form.customerCfmException"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "down-four section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "125px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlType") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "57",
                                disabled: _vm.isCrossTenantSEToSI
                              },
                              on: {
                                change: function(val) {
                                  _vm.pm.cmbreleaseTypeMBL_changeHandler(val)
                                }
                              },
                              model: {
                                value: _vm.form.releaseType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "releaseType", $$v)
                                },
                                expression: "form.releaseType"
                              }
                            },
                            _vm._l(_vm.blModeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.serialNumber
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlType2") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "58",
                              disabled: _vm.isCrossTenantSEToSI,
                              "select-type":
                                _vm.selectTypeNames.basic_data_OrderFormType,
                              filterable: "",
                              "default-value": _vm.form.issuerBL,
                              clearable: false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cmbissuerHBL_changeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlProperty") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "59",
                                value: _vm.job.typeHBL || 1,
                                disabled:
                                  _vm.cmbtypeHBLDisabled ||
                                  _vm.isCrossTenantSEToSI,
                                clearable: false
                              },
                              on: {
                                input: function(val) {
                                  _vm.pm.cmbtypeHBLChangeHandler(val)
                                }
                              }
                            },
                            _vm._l(_vm.BILL_TYPES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.job.jointMasterHBLUuid,
                              expression: "job.jointMasterHBLUuid"
                            }
                          ],
                          attrs: { label: _vm.$t("SeaExport.HBLHBR") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "60",
                              value: _vm.job.jointMasterHBL
                                ? _vm.job.jointMasterHBL.jobNo
                                : "",
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "61",
                              value: _vm.lblReleaseState,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "6px" },
                              attrs: {
                                no: "62",
                                value: _vm.form.releaseReview === 1,
                                disabled: true
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DataSent")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "6px" },
                              attrs: {
                                no: "63",
                                value: _vm.form.payable,
                                disabled: true
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Completed")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "0px" },
                              attrs: {
                                no: "64",
                                value: _vm.form.withhold,
                                disabled: true
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CargoDetention")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfcompletion") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "65",
                              disabled: true,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.agreePayDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agreePayDate", $$v)
                              },
                              expression: "form.agreePayDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DateOfCargoDetention")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "66",
                              disabled: true,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.withholdDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "withholdDate", $$v)
                              },
                              expression: "form.withholdDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ParamRemark") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "67",
                                filterable: "",
                                "allow-create": ""
                              },
                              model: {
                                value: _vm.form.printParam4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam4", $$v)
                                },
                                expression: "form.printParam4"
                              }
                            },
                            _vm._l(_vm.pm.printParam4Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.GenerationOfABillOfLading")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "68" },
                              model: {
                                value: _vm.form.printParam5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam5", $$v)
                                },
                                expression: "form.printParam5"
                              }
                            },
                            _vm._l(_vm.pm.printParam5Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ShippingCompanySCAC")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "69",
                              value: _vm.job.carrierScac || _vm.txtCarrierScAc,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OverseasAgentSCAC")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "70",
                              value: _vm.txtBookingAgentScAc,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ShipperContactTelNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "71" },
                            model: {
                              value: _vm.form.shipperTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperTel", $$v)
                              },
                              expression: "form.shipperTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ConsigneeContactTelNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "72" },
                            model: {
                              value: _vm.form.consigneeTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeTel", $$v)
                              },
                              expression: "form.consigneeTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.NotifyPartyTelNo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "73" },
                            model: {
                              value: _vm.form.notifyTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyTel", $$v)
                              },
                              expression: "form.notifyTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CNTRNOSSEALNOS") }
                        },
                        [
                          _c("cargo-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "74",
                              "auto-uppercase": true,
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                                  _vm.form.container,
                                  function(val) {
                                    _vm.form.container = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.container,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "container", $$v)
                              },
                              expression: "form.container"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ReasonOfCargoDetention")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "75",
                              value: _vm.form.withholdReason,
                              type: "textarea",
                              rows: 5,
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "76",
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  disabled: !_vm.isEdit
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "77", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "78" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: {
              visible: _vm.billAddressDialog.visible,
              job: _vm.billAddressDialog.job,
              params: _vm.billAddressDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _c("search-bill-no-dialog", {
            attrs: {
              visible: _vm.searchBillNoDialog.visible,
              params: _vm.searchBillNoDialog.params,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
              },
              selected: function(p) {
                _vm.pm.selectionItemHandler(p)
              }
            }
          }),
          _c("transcribe-dialog", {
            attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.transcribeDialog, "visible", $event)
              },
              callback: _vm.transcribeCallback
            }
          }),
          _c("address-format-dialog", {
            attrs: {
              visible: _vm.addressFormatDialog.visible,
              params: _vm.addressFormatDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addressFormatDialog, "visible", $event)
              }
            }
          }),
          _c("batch-checking-window", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.batchCheckingWindow.visible,
                expression: "batchCheckingWindow.visible"
              }
            ],
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          }),
          _c("checking-window", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.checkingWindow.visible,
                expression: "checkingWindow.visible"
              }
            ],
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          }),
          _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context,
              "pre-print-callback": _vm.prePrintCallback,
              "printed-callback": _vm.printedCallback,
              "v2-check-callback": _vm.v2CheckCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "79",
                visible: _vm.editDialog.visible,
                title: _vm.editDialog.title,
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.editDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.chargeItem") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "80",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.chargeItemId || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.chargeItemId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeClause") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "81",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.paymentTermHBL
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.paymentTermHBL = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Message.CurrencyExchangeRateIsNotMaintained1"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "82",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              filterable: "",
                              "default-value": _vm.editDialog.form.currency
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.currency = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "83",
                              "select-type":
                                _vm.selectTypeNames.local_cache_EQSize,
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqSize
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqSize = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerType") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "84",
                              "select-type":
                                _vm.selectTypeNames.basic_data_EQType,
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqType = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.quantity") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "85", precision: 0, controls: false },
                            on: { change: _vm.caculateAmount },
                            model: {
                              value: _vm.editDialog.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "quantity", $$v)
                              },
                              expression: "editDialog.form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.unitPrice") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "86", precision: 2, controls: false },
                            on: { change: _vm.caculateAmount },
                            model: {
                              value: _vm.editDialog.form.unitRate,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "unitRate", $$v)
                              },
                              expression: "editDialog.form.unitRate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.amount") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "87", precision: 2, controls: false },
                            on: {
                              change: function($event) {
                                _vm.editDialog.form.unitRate =
                                  _vm.editDialog.form.amount
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "amount", $$v)
                              },
                              expression: "editDialog.form.amount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "88", type: "primary" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "89" },
                      on: {
                        click: function($event) {
                          _vm.editDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }